import { StyleSheet } from "react-native";
import { colorList } from 'utils/colors'
import { ThemedValues } from 'styles/themed'

export const styles = StyleSheet.create({
	selectionFilter: {
	},
	okButtonContainer:{
		alignItems: 'center',
		justifyContent: 'center',
		position: 'absolute',
		bottom: 20,
		left: 10,
		right: 10,
	},
	listContainer: {
		paddingVertical: 0,
		paddingHorizontal: 0
	},
	listItem: {},
	listItemIcon: {},
	
	filterContainer: {
		paddingBottom: 0,
	},
	filterName: {
		paddingHorizontal: 10
	},
	filterTitle: {
		flex: 1,
		flexDirection: 'row',
		alignItems: 'center',
		justifyContent: 'flex-start',
		marginHorizontal: 4
	},
	iconHeader:{
		height: 26,
		width: 26,
		marginRight: 5
	},
	okButton: {
		flex: 1,
	},
	checkBox: {
		marginBottom: 10
	},
	checkBoxLast: {
		marginBottom: 0
	},
	input: {
		paddingHorizontal: 16,
		paddingRight: 40,
		paddingVertical: 0,
		minHeight: 48,
		borderColor: colorList.GREY.dark,
		borderRadius: ThemedValues.borderRadius,
		borderWidth: 1,
	},
	emptyHint: { padding: 16, textAlign: 'center', color: colorList.TEXT_HINT.primary, fontSize: 14 },
});
